import { Component } from '@angular/core';

@Component({
  selector: 'app-error-storeid-missing',
  templateUrl: './error-storeid-missing.component.html',
  styleUrls: ['./error-storeid-missing.component.scss'],
  standalone: false,
})
export class ErrorStoreIdMissingComponent {}
